module.exports = __webpack_public_path__ + "img/footer_company_07.f8fd4c0f.png";